import { getConfig } from "@jti/fe-common";
import { getUser } from "../../utils";
import { QuizApiEvo } from "./QuizApiEvo";
const user = getUser();
export class QuizApi {
    static init() {
        const config = getConfig();
        return new QuizApiEvo(config.EVO_DOMAIN, config.EVO_TENANT, user.ciam_token);
    }
}
//# sourceMappingURL=QuizApi.js.map